import { useLang } from "@/i18n/LanguageContext";

// Slow editorial marquee. CSS animation, pauses under reduced-motion.
export function Marquee() {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div className="relative overflow-hidden border-y border-edge bg-asphalt py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {Array.from({ length: 3 }).map((_, i) => (
              <span key={i} className="mx-8 font-display text-lg font-semibold uppercase tracking-widest text-steel">
                {text}
                <span className="mx-8 text-amber">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
